(function() {
	'use strict';
	angular.module('quantixApp').factory('query', query);
	query.$inject = [ 'baseRequest' ];
	function query(baseRequest) {
		return function(f, url) {
			var args = f.filterExpressions;
			if (args) {
				for ( var i in args) {
					delete args[i].filterControl; //we dont want to send a UIComponent to the server - not needed (and cannot serialize!)
				}
			}
			var seTextndColm = [];
			if (f.filterExpressions != undefined
					&& f.filterExpressions.length > 0) {
				angular.forEach(f.filterExpressions, function(data) {
					return seTextndColm.push({
						searchText : data.expression,
						searchColumn : data.columnName
					})
				})
			}
			var filter = { //just send the entire filter object for the server to convert to SQL Statement.
				pageNumber : f.pageIndex + 1 || 1,
				pageSize : f.pageSize || 20,
				sort : (f.sorts != undefined && f.sorts.length > 0) ? ((f.sorts[0].isAscending) ? "asc"
						: "desc")
						: "asc",
				sortColumn : (f.sorts != undefined && f.sorts.length > 0) ? f.sorts[0].sortColumn
						: null,
				searchTextAndColumn : seTextndColm,
				searchText : f.searchText
			// searchColumn:(f.filterExpressions!=undefined && f.filterExpressions.length>0)?f.filterExpressions[0].columnName:null
			};
			return baseRequest(url, filter).then(function(r) {
				return r.data;
			});
		}
	}
})();